import { format, isAfter, isBefore, isEqual } from 'date-fns'
import { API_CONFIG, API_LIST } from '../Constants/ApiDefinations'
import { CONSTANTS } from '../Constants/Constant'
import { CONFIG } from '../Constants/Constant/Configs'
import { TypeObject } from '../Models'
import mainApiService from '../Services'
import { store } from '../Store'
import { showAlert } from '../Store/Slice/alert.slice'
import { findOutboundPartnerMarkDoneStatus } from './OutboundPartnerHelper'
import {
  getPackageMasterValue,
  nullValuesPresent,
  replaceLabelsWithKeys,
  saveTransactionIDInStorage,
} from './Util'

interface masterType {
  key: string
  value: string
}

export const areDatesEqual = (date1: any, date2: any) =>
  format(date1, 'yyyy-MM-dd"T"HH:mm:ss.SSSxxx') === format(date2, 'yyyy-MM-dd"T"HH:mm:ss.SSSxxx')

export const checkScheduleStatus = (schedules: Array<any>, dateTimeToCheck: any) => {
  const now = new Date()
  const filteredSchedules = schedules.filter((schedule) =>
    isAfter(new Date(schedule.scheduleTime), now),
  )
  const dateTimeToCheckDate = new Date(dateTimeToCheck)

  const pastSchedules = filteredSchedules.filter((schedule) =>
    isBefore(new Date(schedule.scheduleTime), dateTimeToCheckDate),
  )
  const currentSchedules = filteredSchedules.filter((schedule) =>
    isEqual(new Date(schedule.scheduleTime), dateTimeToCheckDate),
  )
  const futureSchedules = filteredSchedules.filter((schedule) =>
    isAfter(new Date(schedule.scheduleTime), dateTimeToCheckDate),
  )

  let scheduleRes: any = false
  if (currentSchedules.length) {
    scheduleRes = CONSTANTS.MESSAGES.SCHEDULE_SAME_EXIST
  } else if (pastSchedules.length && futureSchedules.length) {
    scheduleRes = CONSTANTS.MESSAGES.SCHEDULE_BOTH_EXIST
  } else if (pastSchedules.length) {
    scheduleRes = CONSTANTS.MESSAGES.SCHEDULE_EARLIER_EXIST
  } else if (futureSchedules.length) {
    scheduleRes = CONSTANTS.MESSAGES.SCHEDULE_FUTURE_EXIST
  }

  return scheduleRes
}

export const validateContentCanBeEdited = async (
  contentId: string,
  blitzId: string,
  contentCategory?: any,
  metaCategory?: any,
  assetType?: any,
) => {
  try {
    const requestedData = API_CONFIG(
      API_LIST.CONTENT.VALIDATE_DRAFT_EXISTS,
      {},
      { contentId: contentId },
      {
        blitzId: blitzId,
        assetType: assetType,
        contentCategory: contentCategory,
        metaCategory: metaCategory,
      },
      { metacategoryTxnId: saveTransactionIDInStorage(contentId, metaCategory as string) },
    )

    const result: any = await mainApiService(requestedData)
    if (result.data) {
      if (result.data?.canArchieved) {
        store.dispatch(
          showAlert([
            true,
            'Please refresh the page. Current asset status is changed to archive.',
            'error',
          ]),
        )
        return 'archived'
      }
      return result.data.canEdit
    }
    return null
  } catch (error) {
    return null
  }
}

export const checkDraftBeforeEditingMode = async (
  contentDetails: any,
  metaCategory: any,
  dispatchFn: any,
  setLoaderFn: any,
  navigateFn: any,
  showDialogFn: any,
  showAlertFn: any,
  metadataTab?: any,
  blockNavigation?: boolean,
  langVariantId?: string | null,
) => {
  try {
    const { _id, contentId, contentCategory, assetCategory, assetType, state } = contentDetails

    const navUrl = `/asset/${'update'}/${_id}/${assetType}/${contentCategory}/${assetCategory}/${metaCategory}${
      langVariantId ? `?langVariantId=${langVariantId}` : ''
    }`
    dispatchFn(setLoaderFn(true))
    const canEdit = await validateContentCanBeEdited(
      _id,
      contentId,
      contentCategory,
      metaCategory,
      assetType,
    )
    if (canEdit === 'archived') {
      dispatchFn(setLoaderFn(false))
      return false
    }

    const isCurrentDraft = checkContentStateIsDraftReady(state)

    if ((canEdit && isCurrentDraft) || state === CONSTANTS.ASSET_STATUS.CREATED) {
      if (!blockNavigation) {
        saveTransactionIDInStorage(_id, metaCategory)
        navigateFn(navUrl, {
          state: {
            fromTab: metadataTab,
          },
        })
      }
      dispatchFn(setLoaderFn(false))
      return true
    } else {
      showDialogFn('confirm', {
        title: CONSTANTS.MESSAGES[canEdit ? 'DRAFT_CREATE' : 'DRAFT_UPDATE'],
        description: CONSTANTS.MESSAGES[canEdit ? 'EDIT_DRAFT_NOT_EXIST' : 'EDIT_DRAFT_EXIST'],
        icon: canEdit ? 'DeleteRoleWarIcon' : 'DeleteRoleIcon',
        btn1Label: CONSTANTS.BTN_LABEL_CANCEL,
        btn2Label: CONSTANTS.BTN_LABEL_PROCEED,
        btn2Color: canEdit ? 'warning' : 'error',
        onConfirm: async () => {
          const requestedData: any = API_CONFIG(API_LIST.CONTENT.CREATE_OVERIDE_VERSION, {
            contentId: _id,
          })
          dispatchFn(setLoaderFn(true))
          const result = await mainApiService(requestedData)
          dispatchFn(setLoaderFn(false))
          if (result?.data?._id) {
            dispatchFn(
              showAlertFn([
                true,
                CONSTANTS.MESSAGES[canEdit ? 'DRAFT_CREATED' : 'DRAFT_UPDATED'],
                'success',
              ]),
            )
            saveTransactionIDInStorage(_id, metaCategory)
            navigateFn(
              `/asset/${'update'}/${
                result?.data?._id
              }/${assetType}/${contentCategory}/${assetCategory}/${metaCategory}`,
              {
                state: {
                  fromTab: metadataTab,
                },
              },
            )
          } else if (result.error && result.error.message) {
            dispatchFn(showAlertFn([true, result.error.message, 'error']))
          } else {
            dispatchFn(showAlertFn([true, CONSTANTS.MESSAGES.API_ERROR, 'error']))
          }
        },
        onClose: () => {
          console.log('close')
        },
      })
      dispatchFn(setLoaderFn(false))
      return false
    }
  } catch (error) {
    dispatchFn(setLoaderFn(false))
    return false
  }
}

export const checkContentStateIsDraft = (contentState: string | undefined) => {
  return (
    contentState === CONSTANTS.ASSET_STATUS.CREATED ||
    contentState === CONSTANTS.ASSET_STATUS.DRAFT ||
    contentState === CONSTANTS.ASSET_STATUS.DRAFT_COMPLETE
  )
}

export const checkContentStateIsDraftReady = (contentState: string | undefined) => {
  return (
    checkContentStateIsDraft(contentState) ||
    contentState === CONSTANTS.ASSET_STATUS.DRAFT_READY_FOR_PUBLISHING
  )
}

export const customSort = (dataArray: any, sortKeys: any, sortKey: any = '') => {
  return dataArray.sort((a: any, b: any) => {
    const indexA = sortKeys.indexOf(sortKey ? a[sortKey] : a)
    const indexB = sortKeys.indexOf(sortKey ? b[sortKey] : b)

    if (indexA === -1 && indexB === -1) {
      return 0
    } else if (indexA === -1) {
      return 1
    } else if (indexB === -1) {
      return -1
    }

    return indexA - indexB
  })
}

export const insertAtPositionInArray = (array: any, elementToInsert: any, position: number) => {
  const newArray = array.slice()
  newArray.splice(position - 1, 0, elementToInsert)
  return newArray
}

export const checkForRolePermissions = (tollgate: any, metaCategory: any) => {
  if (localStorage?.getItem(CONSTANTS.LOCAL_KEYS.ROLE_DATA)) {
    const permissions = JSON.parse(localStorage.getItem(CONSTANTS.LOCAL_KEYS.ROLE_DATA) as string)
    const metaCategories = permissions?.find((item: any) => item.key === 'TOLLGATES')
    const permission = metaCategories?.submodules?.find((item: any) => item?.key === metaCategory)
    if (!tollgate) return false
    if (tollgate) {
      if (permission?.permission?.canSkipValidation) {
        return false
      }
      if (permission?.permission?.canStateTransition) {
        return 'skip'
      }
      if (
        !permission?.permission?.canStateTransition &&
        !permission?.permssion?.canSkipValidation
      ) {
        return true
      }
      return 'skip'
    }
  } else {
    return 'skip'
  }
}

export const checkForRightsPermissions = (metaCategory: any) => {
  if (localStorage?.getItem(CONSTANTS.LOCAL_KEYS.ROLE_DATA)) {
    const permissions = JSON.parse(localStorage.getItem(CONSTANTS.LOCAL_KEYS.ROLE_DATA) as string)
    const metaCategories = permissions?.find((item: any) => item.key === 'META_CATEGORIES')
    const permission = metaCategories?.submodules?.find((item: any) => item?.key === metaCategory)

    if (permission?.permission?.canRead && permission?.permission?.canWrite) {
      return true
    }
    if (!permission?.permission?.canWrite) {
      return false
    }
  } else {
    return false
  }
}

export const removeLastSlashes = (input: string, count: number) => {
  const parts = input.split('/')
  const result = parts.slice(0, -count).join('/')
  return result
}

export const sortedData = (data: masterType[]) => {
  if (!data) return
  return JSON.parse(JSON.stringify(data))?.sort((a: any, b: any) => {
    const aStartsWithNumber = /^\d/.test(a.value)
    const bStartsWithNumber = /^\d/.test(b.value)

    if (aStartsWithNumber && !bStartsWithNumber) {
      return 1
    } else if (!aStartsWithNumber && bStartsWithNumber) {
      return -1
    } else {
      return a.value?.localeCompare(b.value)
    }
  })
}

const ensureArrayLength = (array: any[], length: number) => {
  while (array.length < length) {
    array.push({})
  }
}

export const extractMessages = (obj: any, parentKey?: string) => {
  const result: any = {}
  let messages: string[] = []
  for (const attrKey in obj) {
    let tempMessages: string[] = []
    if (typeof obj[attrKey] === 'object') {
      if ('message' in obj[attrKey]) {
        messages.push(`${parentKey ?? attrKey} ${obj[attrKey]['message']}`)
        tempMessages.push(`${parentKey ?? attrKey} ${obj[attrKey]['message']}`)
      }
      const extractedMessages: TypeObject = extractMessages(obj[attrKey], parentKey ?? attrKey)
      messages = messages.concat(extractedMessages.messages)
      tempMessages = tempMessages.concat(extractedMessages.messages)
    }

    const objKey = parentKey ?? attrKey
    result[objKey] =
      (result[objKey] ? result[objKey] : '') +
      (!result[objKey] ? tempMessages.join('\n') : '\n' + tempMessages.join('\n'))
  }
  return { messages, result }
}

export const handleMarkDoneErrors = (array: string[]): any => {
  const result: any = {}
  array.forEach((item: string) => {
    const errorMatches = item.match(/"([^"]+)"/)
    if (errorMatches) {
      const keys = errorMatches[1].split('.')
      let currentObj: any = result
      keys.forEach((key: string, index: number, array: string[]) => {
        const matches = key.match(/(.+?)\[(\d+)\]/)
        const isArrayElement = matches !== null
        const keyWithoutArray = isArrayElement ? matches[1] : key
        if (!currentObj[keyWithoutArray] && errorMatches) {
          if (index === array.length - 1) {
            currentObj[keyWithoutArray] =
              keyWithoutArray + '' + (item?.split?.(errorMatches[0])[1] ?? '')
          } else {
            currentObj[keyWithoutArray] = isArrayElement ? [] : {}
          }
        }
        if (isArrayElement) {
          const arrayIndex = parseInt(matches[2], 10)
          ensureArrayLength(currentObj[keyWithoutArray], arrayIndex + 1)
          currentObj = currentObj[keyWithoutArray][arrayIndex]
        } else {
          currentObj = currentObj[keyWithoutArray]
        }
      })
    }
  })
  try {
    const reslut2 = convertMessagesToKeyValue(result)
    const result3: any = {}
    for (const key in reslut2) {
      const parts = key.split('.')
      if (!result3[parts[0]]) {
        result3[parts[0]] = {}
      }
      if (parts.length > 2) {
        result3[parts[0]][parts[1]] = `${parts.slice(1, -1).join(' ')} ${reslut2[key]}`
      } else {
        result3[parts[0]][parts[1]] = reslut2[key]
      }
    }
    return result3
  } catch (error) {
    return result
  }
}

const convertMessagesToKeyValue = (obj: any, prefix = '') => {
  const result: any = {}
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      result[prefix + key] = obj[key]
    } else if (Array.isArray(obj[key])) {
      obj[key].forEach((item: any, index: number) => {
        const newPrefix = `${prefix}${key}.[${index}].`
        Object.assign(result, convertMessagesToKeyValue(item, newPrefix))
      })
    } else if (typeof obj[key] === 'object') {
      Object.assign(result, convertMessagesToKeyValue(obj[key], `${prefix}${key}.`))
    }
  }
  return result
}

export const replaceIfStartsWith = (
  originalString: string,
  searchString: string,
  replacement: string,
) => {
  if (originalString.startsWith(searchString)) {
    return replacement + originalString.slice(searchString.length)
  }
  return originalString
}

export const updateErrorMessagesByFieldLabel = (
  errorsObj: any = {},
  fields: any = [],
  attributes: TypeObject[] = [],
) => {
  const updatedErrors: any = []
  try {
    const fieldsLinear = fields?.reduce((prev: any, cur: any) => {
      prev[cur.fieldName] = cur.label
      return prev
    }, {})

    const handleErrorObj = (errorsObjCopy: any) => {
      for (const fieldName in errorsObjCopy) {
        const error = errorsObjCopy[fieldName]
        if (fieldsLinear[fieldName]) {
          const label = fieldsLinear[fieldName]
          if (typeof error === 'string') {
            const updatedError = replaceIfStartsWith(error, fieldName, label)
            updatedErrors.push(replaceFieldNameWithLabel(attributes, updatedError))
          } else if (typeof error === 'object' && Array.isArray(error)) {
            error.forEach((errorObjFromArray: any) => {
              for (const key in errorObjFromArray) {
                handleErrorObj({ [fieldName]: `${fieldName} ${errorObjFromArray[key]}` })
              }
            })
          }
        } else {
          updatedErrors.push(replaceFieldNameWithLabel(attributes, error))
        }
      }
    }
    handleErrorObj({ ...errorsObj })
  } catch (error) {
    console.log(error)
  }
  return updatedErrors
}

export const updateValueMasters = (masterData: any, masterKeys: string[]) => {
  const preserveMasterOrderKeys = ['RELEASE_FREQUENCY']

  const data = masterKeys.map((key) => {
    const matchingKey = Object.keys(masterData).find(
      (originalKey) => originalKey.toLowerCase() === key.toLowerCase(),
    )
    const masterValues = matchingKey ? [...(masterData[matchingKey] || [])] : []

    return {
      key,
      data: preserveMasterOrderKeys.includes(key.toUpperCase())
        ? masterValues
        : sortedData(masterValues),
    }
  })
  const updatedData: any = [...data]

  const applyKeyAndValueLabelFormat = (masterKey: string) => {
    const masterIndex = data.findIndex((item: any) => item.key === masterKey)
    if (masterIndex < 0) return

    const masterItem = data[masterIndex]
    updatedData[masterIndex] = {
      key: masterItem?.key,
      data: masterItem?.data.map((item: any) => ({
        ...item,
        value: `${item.key}  ${item.value}`,
      })),
    }
  }

  applyKeyAndValueLabelFormat('COUNTRIES')
  applyKeyAndValueLabelFormat('STATES')

  return updatedData
}

export const filterOutboundPartnerAttributes = (attributes: any[]) => {
  const partners = new Set<string>()

  const filteredAttributes = attributes.filter((attribute: any) => {
    const hasPartners =
      Array.isArray(attribute.outboundPartners) && attribute.outboundPartners.length > 0

    if (hasPartners) {
      attribute.outboundPartners.forEach((partner: string) => partners.add(partner))
    }

    return hasPartners
  })

  return {
    partnerAttributes: filteredAttributes,
    outboundPartners: [...partners],
  }
}

export const updateCategoriesBasedOnAttributes = (
  categories: any,
  attributes: any,
  outboundPartnerEvents: any = {},
) => {
  const filteredCategories = categories.filter((category: any) =>
    attributes.some((attribute: any) => {
      const metaAttributes = attribute.metaAttributes || []

      return attribute.metaCategoryKey === category.metaCategoryKey && metaAttributes.length > 0
    }),
  )

  const partners = new Set<string>()

  const hasPartnerMetadata = attributes.some((attribute: any) => {
    const { partnerAttributes, outboundPartners } = filterOutboundPartnerAttributes(
      attribute?.metaAttributes || [],
    )

    outboundPartners.forEach((partner: string) => partners.add(partner))

    return partnerAttributes.length > 0
  })

  if (hasPartnerMetadata && filteredCategories.length > 0) {
    filteredCategories.push({
      metaCategoryKey: CONSTANTS.CATEGORIES.PARTNER_METADATA,
      metaAttributes: [],
      metaCategoryName: CONSTANTS.CATEGORIES_LABEL.PARTNER_METADATA,
      _id: 'contentId',
      markDoneStatus: findOutboundPartnerMarkDoneStatus(
        outboundPartnerEvents,
        [...partners], // Convert Set to array
      ),
    })
  }

  return filteredCategories
}

export const validateOtherAndDependentChild = (validationData: TypeObject, versionId: string) => {
  let otherVersions = false,
    dependentChilds = false
  if (validationData[1]?.data?.length) {
    dependentChilds = Boolean(
      validationData[1].data.filter((item: any) => !item?.result?.isStandAlonePublishing)?.length,
    )
  }
  if (validationData[0]?.payload?.data?.length) {
    otherVersions = !!validationData[0].payload.data.filter(
      (version: any) => version._id !== versionId,
    ).length
  }
  return { otherVersions, dependentChilds }
}

export const getDePublishDialogDetails = (errorType: number) => {
  let btn1Label, btn2Label, description
  if (errorType === 1) {
    btn1Label = CONSTANTS.BTN_LABEL_CANCEL
    btn2Label = CONSTANTS.BTN_LABEL_PROCEED
    description = CONSTANTS.MESSAGES.DE_PUBLISH_VERSIONS_EXIST
  } else if (errorType === 2) {
    btn1Label = CONSTANTS.BTN_LABEL_OKEY
    description = CONSTANTS.MESSAGES.DE_PUBLISH_LINKED_EXIST
  } else if (errorType === 3) {
    btn1Label = CONSTANTS.BTN_LABEL_CANCEL
    btn2Label = CONSTANTS.BTN_LABEL_YES
    description = CONSTANTS.MESSAGES.DE_PUBLISH_CONFIRM
  }
  return { btn1Label, btn2Label, description }
}

export const openAssetInNewTab = (item: any) => {
  const { _id, assetType, contentCategory, assetCategory } = item
  const url = CONSTANTS.APP_URL
  window.open(
    `${url}/asset/view/${_id}/${assetType}/${contentCategory}/${assetCategory}/${CONSTANTS.CATEGORIES.RIGHTS_AND_AVAILABILITY}`,
    '_blank',
  )
}

export const handleComplexFieldErrors = (errorsArray: any, metaCategory = '') => {
  const pathArr: any = []
  let visitedPaths = 0
  errorsArray.forEach((error: any) => {
    if (metaCategory === CONSTANTS.CATEGORIES.CONTENT_MEDIA_VIDEO) {
      if (error.includes('"CONTENT_MEDIA_VIDEO.video[0]"')) {
        error = error.replace(
          '"CONTENT_MEDIA_VIDEO.video[0]"',
          `"CONTENT_MEDIA_VIDEO.video[${visitedPaths}]"`,
        )
        if (error.includes('postSlateEnd" must be greater than "(self)contractEndDate"')) {
          error = `"CONTENT_MEDIA_VIDEO.Post Slate End[${visitedPaths}]" should not be less than Availability End Time of the content`
        } else if (error.includes('preSlate" must be [(self)contractStartDate]')) {
          error = `"CONTENT_MEDIA_VIDEO.Pre Slate Time[${visitedPaths}]" should be equal to Availability Start Time of the content`
        }
        visitedPaths = visitedPaths + 1
      }
    }
    const matches = error.match(/^"([^"]+)"\s(.+)$/)
    if (matches) {
      const path = parseErrorPath(matches[1])
      const message = matches[2].trim()
      pathArr.push([...path, message])
    }
  })

  const errors: any = buildNestedObject(pathArr)
  return errors
}

function parseErrorPath(path: string) {
  const segments = path
    .replace(/\[(\w+)\]/g, '.$1')
    .split('.')
    .filter(Boolean)
  return segments.length > 0 ? segments : []
}

function buildNestedObject(arr: any) {
  const result = {}

  arr.forEach((path: string) => {
    let current: any = result

    for (let i = 0; i < path.length; i++) {
      const key = path[i]
      const isLast = i === path.length - 1

      if (isLast) {
        if (typeof current.message === 'undefined') {
          current.message = key
        } else if (typeof current.message === 'string') {
          current.message = [current.message, key].join(',')
        } else {
          if (!current.errors) {
            current.errors = []
          }
          const errorIndex = parseInt(key, 10)
          if (!isNaN(errorIndex)) {
            current.errors[errorIndex] = current.errors[errorIndex] || {}
            current.errors[errorIndex].message = path[i + 1]
          } else {
            current[key] = path[i + 1]
          }
        }
      } else {
        if (!isNaN(parseInt(key, 10))) {
          if (!current.errors) {
            current.errors = []
          }
          const errorIndex = parseInt(key, 10)
          current.errors[errorIndex] = current.errors[errorIndex] || {}
          current = current.errors[errorIndex]
        } else {
          current[key] = current[key] || {}
          current = current[key]
        }
      }
    }
  })
  return result
}

export const updateCategoriesValues = (arr: any, attributesData: any) => {
  const metaAttributes = [...arr]

  metaAttributes.forEach((element: any, index: any) => {
    if (element.fieldType !== CONSTANTS.FIELDTYPES.COMPLEXTYPE) {
      metaAttributes[index].attribute.value = attributesData?.[element.fieldName]
    }

    if (element.fieldType === CONSTANTS.FIELDTYPES.COMPLEXTYPE && !element.addMore) {
      element.attribute.attributeRef.forEach((attrChild: any, attrChildIdx: number) => {
        metaAttributes[index].attribute.attributeRef[attrChildIdx].attribute.value =
          attributesData?.[element.fieldName]?.[attrChild.fieldName]
      })
    }
    if (element.fieldType === CONSTANTS.FIELDTYPES.COMPLEXTYPE && element.addMore) {
      element.attribute.forEach((child: any, childIdx: number) => {
        child.attributeRef.forEach((attrChild: any, attrChildIdx: number) => {
          metaAttributes[index].attribute[childIdx].attributeRef[attrChildIdx].attribute.value =
            attributesData?.[element.fieldName]?.[childIdx]?.[attrChild.fieldName]
        })
      })
    }
  })

  return metaAttributes
}

const isApplicableAdBreakPolicyAttribute = (attribute: any) =>
  attribute?.fieldName === 'applicableAdBreakPolicy' ||
  attribute?.label?.trim()?.toLowerCase() === 'applicable ad break policy'

const getAttributeValue = (attribute: any, attributes: TypeObject) => {
  if (isApplicableAdBreakPolicyAttribute(attribute)) {
    return attributes?.applicableAdBreakPolicy ?? ''
  }
  return attributes?.[attribute?.fieldName] ?? ''
}

const getValues = (
  attribute: {
    defaultValue: string | number | boolean
    inheritanceRule: string
    isMultiple: boolean
    fieldType: string
    fieldName: string
    options: TypeObject[]
  },
  value: string | number | boolean,
  detailViewState: TypeObject,
) => {
  const contentState = detailViewState?.data?.state
  const lockedAt = detailViewState?.data?.ContentMetaCategory?.[0]?.lockedAt
  const createdAt = detailViewState?.data?.ContentMetaCategory?.[0]?.createdAt
  const updatedAt = detailViewState?.data?.ContentMetaCategory?.[0]?.updatedAt
  const markDoneStatus = detailViewState?.data?.ContentMetaCategory?.[0]?.markDoneStatus

  if (isApplicableAdBreakPolicyAttribute(attribute)) {
    return value ?? ''
  }

  if (
    contentState === CONSTANTS.ASSET_STATUS.CREATED ||
    (!lockedAt &&
      updatedAt === createdAt &&
      markDoneStatus === 'NO_ACTION' &&
      contentState === CONSTANTS.ASSET_STATUS.DRAFT)
  ) {
    if (attribute?.isMultiple && attribute?.fieldType === CONSTANTS.FIELDTYPES.SELECT) {
      const dv = attribute.defaultValue as string | string[]
      return !dv ? value : Array.isArray(dv) ? dv : dv.split(',').map((item) => item?.trim())
    } else if (attribute && attribute?.inheritanceRule === 'NONE') {
      return attribute.defaultValue ? attribute.defaultValue : value
    } else {
      return value
    }
  } else {
    if (attribute?.fieldName === 'packageId') {
      const masterPackageValue =
        detailViewState?.data?.ContentMetaCategory?.[0]?.attributes?.[
          CONSTANTS.PACKAGE_MASTER_KEY
        ] ?? null

      if (masterPackageValue) {
        const changedPackageKey = attribute.options.find(
          (item: any) => item.value === masterPackageValue,
        )
        if (changedPackageKey) {
          return changedPackageKey?.key
        }
      }
      return value
    } else {
      if (typeof value === 'boolean')
        if (value) return true
        else return false
      else return value
    }
  }
}

export const getDisplayAttributesData = (
  contentData: TypeObject,
  markDoneStatus: TypeObject[],
  complexArray: TypeObject[],
  detailViewState: TypeObject,
  attributes: TypeObject,
  metaCategory: string,
) => {
  const packageIdOptions = contentData?.metaAttributes?.filter(
    (item: any) => item?.fieldName === 'packageId',
  )
  const { data } = detailViewState

  if (contentData) {
    const contentDisplayData: any = {
      metaCategoryLabel: markDoneStatus.find(
        (item: any) =>
          item?.metaCategoryKey ===
          (contentData?.metaCategoryKey || CONSTANTS.CATEGORIES.RIGHTS_AND_AVAILABILITY),
      )?.metaCategoryName,
      ...contentData,
      metaCategory: contentData?.metaCategory ?? '',
      metaAttributes: (() => {
        if (contentData?.metaAttributes?.length) {
          return contentData.metaAttributes
            .filter((cItem: any) => !complexArray.some((dItem: any) => cItem._id === dItem._id))
            .map((contentMetaAttribute: any) => ({
              attribute: (() => {
                if (contentMetaAttribute?.fieldType === CONSTANTS.FIELDTYPES.COMPLEXTYPE) {
                  if (contentMetaAttribute?.addMore) {
                    if (
                      attributes?.[contentMetaAttribute?.fieldName]?.length &&
                      Array.isArray(attributes?.[contentMetaAttribute.fieldName])
                    ) {
                      return attributes?.[contentMetaAttribute.fieldName].map(
                        (attribute: any, index: number) => ({
                          ...contentMetaAttribute,
                          value: getValues(contentMetaAttribute, attribute ?? '', detailViewState),
                          _id: (contentMetaAttribute.fieldName + index).toString(),
                          attributeRef: contentMetaAttribute.attributeRef.map(
                            (attRef: any, attrefIdx: number) => {
                              const attributeRefParent = contentData.metaAttributes.find(
                                (attributeReference: any) =>
                                  attributeReference?._id === attRef?._id,
                              )
                              return {
                                attribute: {
                                  ...attRef,
                                  ...attributeRefParent,
                                  _id: attRef.feildName + index.toString() + attrefIdx.toString(),
                                  value: getValues(
                                    attributeRefParent,
                                    attribute?.[attributeRefParent?.fieldName] ?? '',
                                    detailViewState,
                                  ),
                                },
                                label: attributeRefParent?.label,
                                fieldName: attributeRefParent?.fieldName,
                                fieldType: attributeRefParent?.fieldType,
                                sortOrder: attRef.sortOrder,
                                addMore: attributeRefParent?.addMore,
                                isRequired: attributeRefParent?.isRequired,
                              }
                            },
                          ),
                        }),
                      )
                    } else {
                      return [
                        {
                          ...contentMetaAttribute,
                          value: getValues(
                            contentMetaAttribute,
                            getAttributeValue(contentMetaAttribute, attributes),
                            detailViewState,
                          ),
                          attributeRef: contentMetaAttribute.attributeRef.map((attRef: any) => {
                            const attributeRefParent = contentData.metaAttributes.find(
                              (attribute: any) => attribute?._id === attRef?._id,
                            )
                            return {
                              attribute: {
                                ...attRef,
                                ...attributeRefParent,
                                value: getValues(
                                  attributeRefParent,
                                  attributes?.[contentMetaAttribute.fieldName]?.[
                                    attributeRefParent.fieldName
                                  ] ?? '',
                                  detailViewState,
                                ),
                              },
                              label: attributeRefParent?.label,
                              fieldName: attributeRefParent?.fieldName,
                              fieldType: attributeRefParent?.fieldType,
                              sortOrder: attRef.sortOrder,
                              addMore: attributeRefParent?.addMore,
                              isRequired: attributeRefParent?.isRequired,
                            }
                          }),
                        },
                      ]
                    }
                  } else {
                    return {
                      ...contentMetaAttribute,
                      value: getValues(
                        contentMetaAttribute,
                        getAttributeValue(contentMetaAttribute, attributes),
                        detailViewState,
                      ),
                      attributeRef: contentMetaAttribute?.attributeRef
                        ? contentMetaAttribute.attributeRef.map((attRef: any) => {
                            const attributeRefParent = contentData.metaAttributes.find(
                              (attributeReference: any) => attributeReference?._id === attRef?._id,
                            )
                            return {
                              attribute: {
                                ...attRef,
                                ...attributeRefParent,
                                value: getValues(
                                  attributeRefParent,
                                  attributes?.[contentMetaAttribute.fieldName]?.[
                                    attributeRefParent.fieldName
                                  ] ?? '',
                                  detailViewState,
                                ),
                              },
                              label: attributeRefParent?.label,
                              fieldName: attributeRefParent?.fieldName,
                              fieldType: attributeRefParent?.fieldType,
                              sortOrder: attRef.sortOrder,
                              addMore: attributeRefParent?.addMore,
                              isRequired: attributeRefParent?.isRequired,
                            }
                          })
                        : [],
                    }
                  }
                } else {
                  return {
                    ...contentMetaAttribute,
                    value:
                      contentMetaAttribute.fieldName === CONSTANTS.PACKAGE_MASTER_KEY
                        ? getPackageMasterValue(
                            packageIdOptions[0].options,
                            data.ContentMetaCategory[0].attributes[CONSTANTS.PACKAGE_MASTER_KEY],
                          )
                        : getValues(
                            contentMetaAttribute,
                            getAttributeValue(contentMetaAttribute, attributes),
                            detailViewState,
                          ),
                    detailViewState,
                  }
                }
              })(),
              fieldName: contentMetaAttribute?.fieldName,
              fieldType: contentMetaAttribute?.fieldType,
              label: contentMetaAttribute?.label,
              sortOrder: contentMetaAttribute?.sortOrder,
              addMore: contentMetaAttribute?.addMore,
              isRequired: contentMetaAttribute?.isRequired,
            }))
        } else {
          return []
        }
      })(),
    }

    return contentDisplayData
  } else {
    const d: any = {
      metaCategoryLabel: markDoneStatus.find(
        (item: any) =>
          item?.metaCategoryKey === (metaCategory || CONSTANTS.CATEGORIES.DESCRIPTIVE_METADATA),
      )?.metaCategoryName,

      metaCategory: metaCategory ?? '',
      metaAttributes: [],
    }

    return d
  }
}

export const getComplexAttributes = (contentData: TypeObject) => {
  return contentData?.metaAttributes?.length
    ? contentData?.metaAttributes
        ?.filter((item: any) => item.fieldType === CONSTANTS.FIELDTYPES.COMPLEXTYPE)
        .flatMap((item: any) => item.attributeRef)
    : []
}

export const getMastersForSelect = async (
  attributes: any,
  metaCategory: string,
  setLoader: any,
  dispatch: any,
  fetchMasterData: any,
  assetType?: string,
) => {
  const data: any = attributes
    ? attributes.find(
        (x: any) =>
          x?.metaCategory === (metaCategory ?? CONSTANTS.CATEGORIES.RIGHTS_AND_AVAILABILITY),
      )
    : []

  if (data?.metaAttributes?.length) {
    const sortedData = [...data.metaAttributes].sort((a: any, b: any) => {
      if (a.sortOrder < b.sortOrder) return -1
      if (a.sortOrder > b.sortOrder) return 1
      return 0
    })

    const dataWithMasters = await handleMastersForSelect(
      sortedData,
      data,
      dispatch,
      fetchMasterData,
      assetType,
    )

    return dataWithMasters
  }
}

export const getMasterKeyFormAttribute = (attribute: any) => {
  let masterKey = attribute.master.split('/')
  masterKey = masterKey[masterKey.length - 1].toUpperCase().trim()
  return masterKey
}

export const handleMastersForSelect = async (
  attributes: any,
  category: any,
  dispatch: any,
  fetchMasterData: any,
  assetType?: string,
) => {
  const normalizeAssetTypeForAdBreakPolicy = (type: any) => {
    const normalizedType = String(type ?? '')
      .trim()
      .toUpperCase()
      .replace(/[\s_-]/g, '')

    const alias: Record<string, string> = {
      EPISDOE: 'EPISODE',
    }

    return alias[normalizedType] || normalizedType
  }

  const preFetchMasterKeys = [
    'LANGUAGES',
    'AFFILIATEPARTNERS',
    'METACATEGORIES',
    'DOWNSTREAMPLATFORMS',
    'DATASOURCE',
    'COUNTRIES',
    'ENTITLEMENTPACKAGES',
    'GEOPOLICY',
    'AD_LANGUAGES',
    'CC_LANGUAGES',
    'ENTITLEMENT',
    'SEGMENT_ID',
    'METADATA_TABS',
    'OUTBOUND_PARTNERS',
  ]

  const mastersToFetch = [...preFetchMasterKeys]
  attributes.forEach((item: any) => {
    if (item?.master) {
      let masterKey = item.master.toUpperCase().trim()
      if (item.master.includes('SystemConfigurations')) {
        masterKey = getMasterKeyFormAttribute(item)
      }
      if (!mastersToFetch.includes(masterKey)) {
        mastersToFetch.push(masterKey)
      }
    }
  })

  const mastersRes = await dispatch(
    fetchMasterData({ masters: mastersToFetch, showLoader: false }) as any,
  )
  const mastersData = updateValueMasters(mastersRes?.payload?.data || {}, mastersToFetch)

  const updatedData = await Promise.all(
    attributes.map(async (item: any) => {
      // Handle SELECT field type
      if (item.fieldType === CONSTANTS.FIELDTYPES.SELECT) {
        // If master is defined, fetch options from mastersData
        if (item?.master) {
          let masterKey = item.master.toUpperCase().trim()
          if (item.master.includes('SystemConfigurations')) {
            masterKey = getMasterKeyFormAttribute(item)
          }
          const itemMaster = mastersData.find((im: any) => im?.key === masterKey)
          let options = itemMaster?.data ?? []

          // Convert option keys to number if required
          if (
            options.length &&
            typeof options[0]?.key === 'string' &&
            item.dataType === CONSTANTS.FIELDTYPES.NUMBER
          ) {
            options = options.map((opt: any) => ({
              ...opt,
              key: Number(opt.key),
            }))
          }

          if (isApplicableAdBreakPolicyAttribute(item) && assetType) {
            const normalizedCurrentAssetType = normalizeAssetTypeForAdBreakPolicy(assetType)
            options = options.filter((opt: any) => {
              const applicableAssetTypes = Array.isArray(opt?.applicableAssetType)
                ? opt.applicableAssetType
                : []

              return applicableAssetTypes.some(
                (type: any) =>
                  normalizeAssetTypeForAdBreakPolicy(type) === normalizedCurrentAssetType,
              )
            })
          }

          return { ...item, options }
        }

        // Boolean select options
        if (item.dataType === CONSTANTS.ASSET_CREATION_OBJ.BOOLEAN) {
          return {
            ...item,
            options: [
              { key: true, value: 'Yes' },
              { key: false, value: 'No' },
            ],
          }
        }

        // Default select options
        return {
          ...item,
          options: Array.isArray(item.options)
            ? item.options.map((opt: any) => ({ key: opt, value: opt }))
            : [],
        }
      }

      // Return item as is for other field types
      return item
    }),
  )

  const preFetchMastersData = mastersData.filter((item: any) =>
    preFetchMasterKeys.includes(item.key),
  )

  return { ...category, metaAttributes: updatedData, mastersData: preFetchMastersData }
}

/**
 * Get the status of recent activities.
 * @function getTooltipMessage
 * @param {boolean} publishingAccess - Published property in tollgates ( Roles and Permission is true or not )
 * @param {boolean} standAloneDisable - property is boolean shows standalone published is true and parent is published or not.
 * @returns {string} - message to show on tooltip.
 */
export const getTooltipMessage = (publishingAccess: boolean, standAloneDisable: boolean) => {
  return !publishingAccess
    ? CONSTANTS.MESSAGES.PUBLISH_DISABLE_MESSAGE
    : standAloneDisable
      ? CONSTANTS.MESSAGES.STANDALONE_DISABLE_MESSAGE
      : ''
}

/**
 * Function to replace fieldName by label
 * @param {array} attributes list of all the attributes
 * @param {string} message message from which fieldName will be replaced by label
 * @returns  {string} update messaged with all the fieldName replaced by label
 */
const replaceFieldNameWithLabel = (attributes: TypeObject[], message: string) => {
  const msg = message
  const labels = attributes.reduce((acc, attribute) => {
    acc[attribute.fieldName] = attribute.label
    return acc
  }, {})
  const regex = new RegExp(`${attributes.map((attr) => attr.fieldName).join('|')}`, 'g')

  return msg.replaceAll(regex, (match) => labels[match])
}

/**
 * @param {string} idxMsg - error message which is on root field
 * @param {string} nestedMsg - error message nested in root field coma separated
 * @returns {string} - returns combination of rootMessage and nestedMessage
 */
export const returnErrorMessage = (
  idxMsg: string,
  nestedMsg: string,
  attribute: TypeObject,
  attributes: TypeObject[],
) => {
  const errorMsg =
    (nestedMsg ? idxMsg + (idxMsg ? '\n ' : '') : idxMsg) + (nestedMsg ? nestedMsg : '')
  const errorMsgWithLabel = replaceFieldNameWithLabel(attributes, errorMsg)
  const updatedErrorMsg = errorMsgWithLabel
    .split('\n')
    .map((msg) => `${attribute?.label} ${msg}`)
    .join('\n')
  return errorMsgWithLabel ? updatedErrorMsg : ''
}

/**
 * Get the status of recent activities.
 * @function getTooltipMessage
 * @param {object} attr - attribute of related meta category
 * @param {number | string} attrIdx - index of complex type object to show the validation
 * @param {string} type - type of field complex, normal or add more
 * @param {object} attrChild - complex type child attribute
 * @param {object} complexFieldErrors - Errors return for field type in particular meta category
 * @param {array} attributes - retrurn list of attributes with fieldname and label
 * @param {number | string} idx - index of complex type object to show the validation
 * @param {boolean} isLiveAssetGroup - true if asset group is live
 * @returns {string} - return error for individual field
 */
export const buildErrorObject = (
  attr: any,
  idx: number | string,
  attrChild: any,
  type: string,
  complexFieldErrors: TypeObject,
  attributes: TypeObject[],
  idxNested: number | string,
  isLiveAssetGroup = false,
) => {
  /**
   * @param {boolean} nested - true / false if message object is on root field or nested data
   * @param {string|object}messages - to return the message as string for root field and object for index field
   * @param {object} attribute - attribute on which that message is applied
   * @returns {string} - return error messages in string format
   */
  const parseErrorData = (nested: boolean, messages: any) => {
    if (nested) {
      return messages
        ?.filter((messages: { message: string }) => messages?.message?.trim())
        .map((messages: { message: string; label: string }) => messages?.message ?? '')
        .join('\n')
    } else {
      return messages ?? ''
    }
  }

  if (type === CONSTANTS.ASSET_CREATION_OBJ.ADDMORE && !isLiveAssetGroup) {
    const rootMsg = parseErrorData(
      false,
      complexFieldErrors?.[attr.fieldName]?.errors?.[idx]?.[attrChild.fieldName]?.message,
    )
    const nestedMsg = parseErrorData(
      true,
      complexFieldErrors?.[attr.fieldName]?.errors?.[idx]?.[attrChild.fieldName]?.errors,
    )
    return returnErrorMessage(rootMsg, nestedMsg, attrChild, attributes)
  } else if (type === CONSTANTS.ASSET_CREATION_OBJ.ADDMORE && isLiveAssetGroup) {
    let rootMsg = '',
      nestedMsg = ''
    const findFieldError = (errorObj: any, fieldName: string): any => {
      if (!errorObj || typeof errorObj !== 'object') {
        return null
      }
      const currentFieldError = errorObj?.[fieldName]
      if (
        currentFieldError &&
        typeof currentFieldError === 'object' &&
        (currentFieldError?.message || currentFieldError?.errors)
      ) {
        return currentFieldError
      }
      if (Array.isArray(errorObj)) {
        for (const item of errorObj) {
          const found = findFieldError(item, fieldName)
          if (found) {
            return found
          }
        }
      }
      if (Array.isArray(errorObj?.errors)) {
        for (const item of errorObj.errors) {
          const found = findFieldError(item, fieldName)
          if (found) {
            return found
          }
        }
      }
      for (const key of Object.keys(errorObj)) {
        if (key === 'message') {
          continue
        }
        const found = findFieldError(errorObj[key], fieldName)
        if (found) {
          return found
        }
      }
      return null
    }
    const indexes = String(idxNested).split('.')
    Object.keys(complexFieldErrors || {}).forEach((key: string) => {
      if (complexFieldErrors[key].errors?.length) {
        const errorsItem1 = complexFieldErrors[key].errors?.[indexes[1]]?.[attrChild.fieldName]
        const errorsItem2 = complexFieldErrors[key].errors?.[indexes[1]]?.[attr.fieldName]
        if (errorsItem1?.message) {
          rootMsg = parseErrorData(false, errorsItem1?.message)
          nestedMsg = parseErrorData(true, errorsItem1?.errors)
        } else if (errorsItem2?.errors) {
          const errorsItem3 =
            errorsItem2.errors?.[indexes[indexes?.length - 2]]?.[attrChild.fieldName]
          if (errorsItem3?.message) {
            rootMsg = parseErrorData(false, errorsItem3?.message)
            nestedMsg = parseErrorData(true, errorsItem3?.errors)
          }
        }
      }
    })

    if (!rootMsg && !nestedMsg) {
      const fallbackFieldError =
        complexFieldErrors?.[attr.fieldName]?.[attrChild.fieldName] ||
        complexFieldErrors?.[attrChild.fieldName] ||
        findFieldError(complexFieldErrors, attrChild.fieldName)
      if (fallbackFieldError) {
        rootMsg = parseErrorData(false, fallbackFieldError?.message)
        nestedMsg = parseErrorData(true, fallbackFieldError?.errors)
      }
    }

    return returnErrorMessage(rootMsg, nestedMsg, attrChild, attributes)
  } else if (type === CONSTANTS.ASSET_CREATION_OBJ.COMPLEX) {
    const rootMsg = parseErrorData(
      false,
      complexFieldErrors?.[attr.fieldName]?.[attrChild.fieldName]?.message,
    )
    const nestedMsg = parseErrorData(
      true,
      complexFieldErrors?.[attr.fieldName]?.[attrChild.fieldName]?.errors,
    )
    return returnErrorMessage(rootMsg, nestedMsg, attrChild, attributes)
  } else if (type === CONSTANTS.ASSET_CREATION_OBJ.NORMAL) {
    const rootMsg = parseErrorData(false, complexFieldErrors?.[attr.fieldName]?.message)
    const nestedMsg = parseErrorData(true, complexFieldErrors?.[attr.fieldName]?.errors)
    return returnErrorMessage(rootMsg, nestedMsg, attr, attributes)
  } else {
    return ''
  }
}

/**
   * @param {object} inputData - The JSON which user entered in JSON Editor
   * @param {string} complexFieldKey - name of the field (complex fieldName)
   * @returns {string} - returns data in below format no matter whatever data coming from field and its important for conversion
   * In case of Add More = true
   *
   * {
      [complexFieldKey]: [
        {
          [complexFieldKey.childFieldName1]: [
            "_af",
            "_teal",
            "_ax"
          ],
          [complexFieldKey.childFieldName2]: 500
        },
        {
          [complexFieldKey.childFieldName1]: [
            "_af",
            "_ax"
          ],
          [complexFieldKey.childFieldName2]: 600
        }
      ]
    }
    *
    * In case of Add More = false
    *
    * {
        [complexFieldKey]: {
            [complexFieldKey.childFieldName1]: [
              "_af",
              "_teal",
              "_ax"
            ],
            [complexFieldKey.childFieldName2]: 500
          }
      }
    *
    *
   */
export const convertJsonToFieldObject = (inputData: any, complexFieldKey: string) => {
  const dataObject: any = { [complexFieldKey]: [] }

  if (complexFieldKey === CONSTANTS.JSON_EDITOR_FIELDS.countryRating) {
    for (const key in inputData) {
      const dataObj = { ratingForCountry: key, countryForRating: inputData?.[key]?.split(',') }
      if (Array.isArray(dataObj.countryForRating)) {
        dataObj.countryForRating = dataObj.countryForRating.map((element) => {
          return `_${element.replace('_', '')}`.toLowerCase()
        })
      }
      dataObject[complexFieldKey].push(dataObj)
    }
  }
  const isPreviewDurationNumber = (value: any) => {
    if (value === '' || value >= 0 || /^-?\d+(\.\d+)?$/.test(value)) {
      return true
    }
    return false
  }
  if (complexFieldKey === CONSTANTS.JSON_EDITOR_FIELDS.countryPreview) {
    const otherSchema = inputData?.filter(
      (item: any) =>
        !Object.prototype.hasOwnProperty.call(item, 'preview_duration') ||
        !Object.prototype.hasOwnProperty.call(item, 'countries') ||
        !isPreviewDurationNumber(item.preview_duration),
    )

    if (otherSchema?.length) {
      return { error: 'JSON value is not consistent with the attribute definition' }
    }
    for (const previewObj of inputData) {
      const dataObj = {
        previewDuration: previewObj?.preview_duration ?? '',
        previewCountry: previewObj?.countries?.split(','),
      }
      if (Array.isArray(dataObj.previewCountry)) {
        dataObj.previewCountry = dataObj.previewCountry.map((element) => {
          return `_${element.replace('_', '')}`.toLowerCase()
        })
      }
      dataObject[complexFieldKey].push(dataObj)
    }
  }
  if (complexFieldKey === CONSTANTS.JSON_EDITOR_FIELDS.isAutoPlayTrailer) {
    const otherSchema =
      Object.prototype.hasOwnProperty.call(inputData, 'disabled_country') &&
      Object.prototype.hasOwnProperty.call(inputData, 'disabled_platform')

    if (!otherSchema) {
      return { error: 'JSON value is not consistent with the attribute definition' }
    }

    const dataObj = {
      disabledCountry: inputData?.disabled_country?.split(','),
      disabledPlatform: inputData?.disabled_platform?.split(','),
    }
    if (Array.isArray(dataObj.disabledCountry)) {
      dataObj.disabledCountry = dataObj.disabledCountry.map((element) => {
        return `_${element.replace('_', '')}`.toLowerCase()
      })
    }
    dataObject[complexFieldKey] = dataObj
  }
  return dataObject
}

/**
   * @param {object} data - This data will be the data returned by above function convertJsonToFieldObject() given below
   * In case of Add More = true
   *
   * {
      [complexFieldKey]: [
        {
          [complexFieldKey.childFieldName1]: [
            "_af",
            "_teal",
            "_ax"
          ],
          [complexFieldKey.childFieldName2]: 500
        },
        {
          [complexFieldKey.childFieldName1]: [
            "_af",
            "_ax"
          ],
          [complexFieldKey.childFieldName2]: 600
        }
      ]
    }
    *
    * In case of Add More = false
    *
    * {
        [complexFieldKey]: {
            [complexFieldKey.childFieldName1]: [
              "_af",
              "_teal",
              "_ax"
            ],
            [complexFieldKey.childFieldName2]: 500
          }
      }
    *
    *
   * @param {string} complexFieldKey - name of the field (complex fieldName)
   * @returns {object} - return object based on the field the object data is mentioned in the story https://sony-liv.atlassian.net/browse/BLITZ-4036
   */
export const convertFieldObjectToJson = (data: any, complexFieldKey: string) => {
  const dataObject: any = data[complexFieldKey]
  let fieldData: any = {}
  if (complexFieldKey === CONSTANTS.JSON_EDITOR_FIELDS.countryRating) {
    const obj: any = {}
    for (const i of dataObject) {
      obj[i?.['ratingForCountry'] ?? ''] = i?.countryForRating ? i.countryForRating.join(',') : ''
    }
    fieldData = obj
  }
  if (complexFieldKey === CONSTANTS.JSON_EDITOR_FIELDS.countryPreview) {
    fieldData = dataObject.map((item: any) => ({
      countries: item?.previewCountry ? item.previewCountry.join(',') : '',
      ['preview_duration']: item.previewDuration,
    }))
  }
  if (complexFieldKey === CONSTANTS.JSON_EDITOR_FIELDS.isAutoPlayTrailer) {
    const dataObj = {
      ['disabled_platform']: data?.disabledPlatform ? data.disabledPlatform.join(',') : '',
      ['disabled_country']: data?.disabledCountry ? data.disabledCountry.join(',') : '',
    }
    fieldData = dataObj
  }
  return fieldData
}

export const processChecklistMarkDoneStatus = (
  categoriesMarkDoneStatus: any[],
  result: any,
  metaAttributesData: any,
  attributes: any,
) => {
  const markData: any = []
  const status: any = []
  const markDoneErrorsInCategory: any[] = []

  categoriesMarkDoneStatus.forEach((ele: any) => {
    result?.data?.forEach((item: any) => {
      if (ele?.metaCategoryKey === item.metaCategory) {
        if (item.errors.length) {
          const complexErrors: any = handleComplexFieldErrors(item.errors ?? [], item.metaCategory)
          const errorObject = extractMessages(complexErrors[item.metaCategory])
          item.errors = updateErrorMessagesByFieldLabel(
            errorObject.result || {},
            metaAttributesData[item.metaCategory],
            attributes,
          )
          status.push(item.errors)
        }
        markDoneErrorsInCategory.push({
          metaCategory: item.metaCategory,
          markDoneStatus: item.errors?.length
            ? CONSTANTS.MARK_DONE_STATUS.FAILED
            : item.markDoneStatus || CONSTANTS.MARK_DONE_STATUS.PASS,
        })
        markData.push({ ...ele, ...item })
      }
    })
  })
  return { status, markDoneErrorsInCategory, markData }
}

export const validateOptions = (
  contentCategoryData: any,
  keyIndex: number,
  inputData: any,
  key: string,
  addMore: boolean,
) => {
  const returnErrorBasedOnFields = (values: any, attributeRefArr: any) => {
    for (const keyValues of values) {
      for (const key in keyValues) {
        const findAttref = attributeRefArr.find((item: any) => item?.fieldName === key)
        const options = findAttref?.attribute?.options ?? []
        if (options?.length) {
          if (typeof keyValues[key] === 'object') {
            for (const value of keyValues[key]) {
              const av = options.find((item: any) => item?.key === value)
              if (!av && value) {
                return { error: 'JSON value is not consistent with the attribute definition' }
              }
            }
          } else {
            const av = options.find((item: any) => item?.key === keyValues[key])
            if (!av && keyValues[key]) {
              return {
                error: 'JSON value is not consistent with the attribute definition',
              }
            }
          }
        }
      }
    }
  }
  if (contentCategoryData?.metaAttributes?.[keyIndex]?.attribute) {
    const attributeRefArr: any = addMore
      ? (contentCategoryData?.metaAttributes?.[keyIndex]?.attribute?.[0]?.attributeRef ?? [])
      : (contentCategoryData?.metaAttributes?.[keyIndex]?.attribute?.attributeRef ?? [])
    const values = inputData[key]
    if (Array.isArray(values)) {
      return returnErrorBasedOnFields(values, attributeRefArr)
    } else {
      return returnErrorBasedOnFields([values], attributeRefArr)
    }
  }
}

export const getNestedMetaAttributeValue = (obj: any, path: string) => {
  const indexes = path.split('.')
  indexes.pop() // Remove the last index to get the parent object
  return indexes.reduce((acc, key: any) => {
    if (Array.isArray(acc)) {
      return acc?.[key]
    } else if (Array.isArray(acc?.attribute)) {
      return acc?.attribute?.[key]
    } else if (Array.isArray(acc?.attributeRef)) {
      return acc?.attributeRef?.[key]
    }
    return acc?.[key]
  }, obj)
}

export const updateContentCategory = (
  fieldType: string,
  value: any,
  type: string,
  idx: number,
  comIdx: number,
  addMoreIdx: number,
  content: any,
) => {
  const contentData: any = { ...content }
  let metaAttribute: any
  if (typeof idx === 'number') {
    metaAttribute = contentData.metaAttributes[idx]
  } else {
    metaAttribute = getNestedMetaAttributeValue(contentData.metaAttributes, String(idx)) // Go deep
  }

  const normalizeFieldToken = (val: any) =>
    String(val ?? '')
      .trim()
      .toLowerCase()
      .replace(/[\s_-]/g, '')

  const normalizeFieldLabel = (val: any) =>
    String(val ?? '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')

  const isApplicableAdBreakPolicyField = (attribute: any) => {
    const fieldName = normalizeFieldToken(attribute?.fieldName)
    const fieldLabel = normalizeFieldLabel(attribute?.label)
    return fieldName === 'applicableadbreakpolicy' || fieldLabel === 'applicable ad break policy'
  }

  const isNaturalAdBreakRequiredField = (attribute: any) => {
    const fieldName = normalizeFieldToken(attribute?.fieldName)
    const fieldLabel = normalizeFieldLabel(attribute?.label)
    return (
      fieldName === 'naturaladbreaksrequired' ||
      fieldName === 'naturaladbreakrequired' ||
      fieldLabel === 'natural ad breaks required'
    )
  }

  const isNaturalAdBreakRequiredEnabled = (selectedValue: any): boolean => {
    if (typeof selectedValue === 'boolean') return selectedValue
    if (typeof selectedValue === 'number') return selectedValue === 1
    if (typeof selectedValue === 'string') {
      const normalizedValue = normalizeFieldToken(selectedValue)
      return ['yes', 'true', '1'].includes(normalizedValue)
    }
    if (selectedValue && typeof selectedValue === 'object') {
      return isNaturalAdBreakRequiredEnabled(
        selectedValue?.key ?? selectedValue?.value ?? selectedValue?.label,
      )
    }
    return false
  }

  const clearApplicableAdBreakPolicyIfNeeded = (selectedValue: any) => {
    if (!isNaturalAdBreakRequiredField(metaAttribute?.attribute)) return
    if (isNaturalAdBreakRequiredEnabled(selectedValue)) return

    const applicableAdBreakPolicyIndex: number = contentData.metaAttributes.findIndex((el: any) =>
      isApplicableAdBreakPolicyField(el?.attribute),
    )

    if (applicableAdBreakPolicyIndex !== -1) {
      contentData.metaAttributes[applicableAdBreakPolicyIndex].attribute.value = ''
    }
  }
  console.log(
    'metaAttribute:',
    metaAttribute,
    'fieldType:',
    fieldType,
    'value:',
    value,
    'type:',
    type,
    'idx:',
    idx,
    'comIdx:',
    comIdx,
    'addMoreIdx:',
    addMoreIdx,
  )
  if (type === CONSTANTS.ASSET_CREATION_OBJ.COMPLEX) {
    if (fieldType === CONSTANTS.ASSET_CREATION_OBJ.SELECT) {
      if (typeof value === 'object') {
        if (Array.isArray(value)) {
          metaAttribute.attribute.attributeRef[comIdx].attribute.value = value.map(
            (item: any) => item.key,
          )
        } else {
          metaAttribute.attribute.attributeRef[comIdx].attribute.value = value?.key ?? ''
        }
      }
    } else {
      metaAttribute.attribute.attributeRef[comIdx].attribute.value = value
    }
  } else if (type === CONSTANTS.ASSET_CREATION_OBJ.ADDMORE) {
    const addMoreAttrRef =
      Array.isArray(metaAttribute.attribute) &&
      metaAttribute.attribute?.[addMoreIdx]?.attributeRef?.[comIdx]
        ? metaAttribute.attribute[addMoreIdx].attributeRef[comIdx]
        : metaAttribute?.attribute?.attributeRef?.[comIdx]

    if (!addMoreAttrRef?.attribute) return contentData

    if (fieldType === CONSTANTS.ASSET_CREATION_OBJ.SELECT) {
      if (typeof value === 'object') {
        if (Array.isArray(value)) {
          addMoreAttrRef.attribute.value = value.map((item) => item.key)
        } else {
          addMoreAttrRef.attribute.value = value?.key
        }
      }
    } else {
      addMoreAttrRef.attribute.value = value
    }
  } else if (fieldType === CONSTANTS.FIELDTYPES.YEAR) {
    if (value instanceof Date) {
      const valueInYear = value?.getFullYear()
      metaAttribute.attribute.value = `${valueInYear}`
    } else {
      metaAttribute.attribute.value = value
    }
  } else {
    if (fieldType === CONSTANTS.ASSET_CREATION_OBJ.SELECT) {
      if (typeof value === 'object') {
        if (metaAttribute.attribute?.fieldName === 'geoPolicyGroupName') {
          const applicableGeoPolicy: number = contentData.metaAttributes.findIndex(
            (el: any) => el.fieldName === 'applicableGeoPolicy',
          )

          if (applicableGeoPolicy !== -1) {
            contentData.metaAttributes[applicableGeoPolicy].attribute.value =
              contentData.metaAttributes[applicableGeoPolicy].attribute.options
                .filter((item: any) =>
                  item.geoPolicyGroupName === value?.key ? value?.key : false,
                )
                .map((item: any) => item.key)
          }

          metaAttribute.attribute.value = value?.key ?? ''
        } else if (metaAttribute.attribute?.fieldName === 'applicableGeoPolicy') {
          const geoPolicyGroupNameIdx: number = contentData.metaAttributes.findIndex(
            (el: any) => el.fieldName === 'geoPolicyGroupName',
          )

          metaAttribute.attribute.value = value.map((item: any) => item.key)

          if (geoPolicyGroupNameIdx !== -1) {
            const geoPolicyGroup =
              value?.filter((item: any) => item.geoPolicyGroupName)?.[0]?.geoPolicyGroupName ?? null

            const notAvailable = value.find((item: any) => !item.geoPolicyGroupName)

            if (notAvailable) contentData.metaAttributes[geoPolicyGroupNameIdx].attribute.value = ''
            else {
              contentData.metaAttributes[geoPolicyGroupNameIdx].attribute.value =
                geoPolicyGroup ?? ''
            }

            const groupNameOptions = metaAttribute.attribute.options.filter(
              (item: any) => item.geoPolicyGroupName === geoPolicyGroup,
            )
            if (groupNameOptions?.length) {
              if (groupNameOptions?.length !== value?.length) {
                contentData.metaAttributes[geoPolicyGroupNameIdx].attribute.value = ''
              }
            }
          }
        } else if (metaAttribute.attribute?.fieldName === 'packageId') {
          const packageMasterKey: number = contentData.metaAttributes.findIndex(
            (el: any) => el.fieldName === CONSTANTS.PACKAGE_MASTER_KEY,
          )

          if (packageMasterKey !== -1) {
            contentData.metaAttributes[packageMasterKey].attribute.value = value?.value ?? ''
          }

          metaAttribute.attribute.value = value?.key ?? ''
        } else if (metaAttribute.attribute?.fieldName === 'broadcastChannel') {
          const allLinearChannelsIdx = contentData.metaAttributes.findIndex(
            (el: any) => el.fieldName === 'allLinearChannels',
          )

          if (allLinearChannelsIdx !== -1) {
            const channels = contentData.metaAttributes[allLinearChannelsIdx].attribute.value
            const oldKey = metaAttribute.attribute.value
            const newKey = value?.key

            const updatedChannels = channels.filter((channel: string) => channel !== oldKey)

            if (newKey && !updatedChannels.includes(newKey)) {
              updatedChannels.push(newKey)
            }

            contentData.metaAttributes[allLinearChannelsIdx].attribute.value = updatedChannels
          }

          metaAttribute.attribute.value = value?.key ?? ''
        } else {
          if (Array.isArray(value)) {
            metaAttribute.attribute.value = value.map((item: any) => item.key)
          } else {
            metaAttribute.attribute.value = value?.key ?? ''
          }
        }
        clearApplicableAdBreakPolicyIfNeeded(value)
      }
    } else if (metaAttribute.fieldName === 'releaseDate') {
      const releaseYearIDX: number = contentData.metaAttributes.findIndex(
        (el: any) => el.fieldName === 'releaseYear',
      )
      const releaseYear = value?.getFullYear()
      // since releaseYearIDX can be zero, checking specificaly for -1
      if (releaseYearIDX !== -1 && releaseYear) {
        contentData.metaAttributes[releaseYearIDX].attribute.value = `${releaseYear}`
      }
      metaAttribute.attribute.value = value
    } else {
      metaAttribute.attribute.value = value
      clearApplicableAdBreakPolicyIfNeeded(value)
    }
  }
  return contentData
}

export const sortTabsByConfig = (
  config: any,
  masterData: any[],
  metaData: any,
  metaCategory?: any,
): any => {
  const genericId = masterData?.find((item) => item.value === 'GENERIC_METADATA')?._id
  // Create a deep copy of metaData to avoid modifying the original object
  const result = JSON.parse(JSON.stringify(metaData))

  // Create a map for quick lookup of master data by value
  const masterMap = new Map<string, any>()
  masterData?.forEach((item: any) => {
    masterMap.set(item.value, item)
  })

  // Create a map for quick lookup of master data by _id
  const masterMapById = new Map<string, any>()
  masterData?.forEach((item: any) => {
    masterMapById.set(item._id, item)
  })

  // Process each category that has a config
  if (config) {
    for (const [, configOrder] of Object.entries(config)) {
      if (!result[metaCategory]) continue

      const categoryTabs = result[metaCategory].tabs
      const orderedTabs: any[] = []

      // First, add tabs in the order specified by config
      for (const configValue of configOrder as string[]) {
        const masterItem = masterMap.get(configValue)
        if (!masterItem) continue

        // Find the tab with matching _id
        const tabIndex = categoryTabs.findIndex((tab: any) => tab.label === masterItem._id)
        if (tabIndex !== -1) {
          orderedTabs.push(categoryTabs[tabIndex])
        }
      }

      // Then, add any remaining tabs not in config, sorted alphabetically by key
      const remainingTabs = categoryTabs.filter(
        (tab: any) => !orderedTabs.some((orderedTab: any) => orderedTab.label === tab.label),
      )
      // Sort remaining tabs alphabetically by their key from master data
      remainingTabs.sort((a: any, b: any) => {
        const aMaster = masterMapById.get(a.label)
        const bMaster = masterMapById.get(b.label)

        if (!aMaster || !bMaster) return 0

        return aMaster.key.localeCompare(bMaster.key)
      })
      const allTabs = [...orderedTabs, ...remainingTabs]
      const genericTabs = allTabs.filter((tab) => tab.label === genericId)
      const nonGenericTabs = allTabs.filter((tab) => tab.label !== genericId)
      // Update the value property to reflect the new order
      const finalTabs = [...genericTabs, ...nonGenericTabs].map((tab: any, index: number) => ({
        ...tab,
        value: index,
      }))

      result[metaCategory].tabs = finalTabs
    }
  }

  return result
}

export const getTabsMetaCateories = (
  metaCategory: string,
  attributes: any,
  selectTabsData: any,
  metadataTabList: any,
  config: any,
) => {
  const sortedTabPosition = sortTabsByConfig(
    config[CONSTANTS.METADATA_TABS_SORT_ORDER],
    metadataTabList,
    selectTabsData,
    metaCategory,
  )
  const tabDataWithValue = replaceLabelsWithKeys(
    sortedTabPosition || selectTabsData,
    metadataTabList,
  )
  const tabsData: any = tabDataWithValue
  const tab = tabsData?.[metaCategory]?.tabs ?? false

  const fieldAvailable = attributes?.some((item: any) => {
    return tabsData?.[metaCategory]?.fieldNames.includes(item.fieldName)
  })

  if (fieldAvailable) return tab
  else {
    return false
  }
}

export const setFieldsByTabs = (
  fieldName: string,
  metadataTab: number,
  metaCategory: string,
  selectTabsData: any,
  master: any,
  config: any,
) => {
  const sortedTabPosition = sortTabsByConfig(
    config[CONSTANTS.METADATA_TABS_SORT_ORDER],
    master,
    selectTabsData,
    metaCategory,
  )
  const tabsData: any = sortedTabPosition
  const isGenericFieldAvailable = !tabsData?.[metaCategory]?.fieldNames?.includes(fieldName)
  if (metadataTab === 0 && isGenericFieldAvailable) {
    return !tabsData?.[metaCategory]?.fieldNames?.includes(fieldName)
  }
  return tabsData?.[metaCategory]?.tabs[metadataTab]?.fields?.includes(fieldName)
}

export const getValuesAttributeField = (value: any, item: any) => {
  if (
    item?.fieldType === CONSTANTS.FIELDTYPES.SELECT &&
    item?.dataType === CONSTANTS.ASSET_CREATION_OBJ.BOOLEAN
  ) {
    if (value === true) {
      return true
    } else if (value === false) {
      return false
    } else {
      return null
    }
  } else {
    return value || null
  }
}

export const validateEmptyValue = (value: any): boolean => {
  return Array.isArray(value) && value.length > 0 && Object.keys(value[0]).length > 0
}

export const prepareAttributesData = (accessDenied: boolean, categoryContent: any) => {
  const attr: any = {}
  if (!accessDenied) {
    if (categoryContent?.metaAttributes && categoryContent?.metaAttributes.length > 0) {
      for (const metaAttribute of categoryContent.metaAttributes) {
        if (metaAttribute?.fieldType !== CONSTANTS.FIELDTYPES.COMPLEXTYPE) {
          if (metaAttribute?.fieldName) {
            attr[metaAttribute.fieldName] =
              metaAttribute.fieldType === CONSTANTS.FIELDTYPES.COMPLEXTYPE
                ? {}
                : getValuesAttributeField(metaAttribute?.attribute?.value, metaAttribute.attribute)
          }
        } else {
          if (
            metaAttribute?.fieldType === CONSTANTS.FIELDTYPES.COMPLEXTYPE &&
            metaAttribute?.addMore &&
            metaAttribute?.fieldName
          ) {
            const attributeValue = metaAttribute.attribute.map((attrItem: any) => {
              const addMoreItemRef: any = {}
              for (const metaAttrChlild of attrItem.attributeRef) {
                if (metaAttrChlild?.fieldName)
                  addMoreItemRef[metaAttrChlild.fieldName] = getValuesAttributeField(
                    metaAttrChlild?.attribute?.value,
                    metaAttrChlild.attribute,
                  )
              }
              const cuePointCondition = nullValuesPresent(addMoreItemRef) ? {} : addMoreItemRef
              return ['cuePointList', 'adCuePointList', 'advisoryCuePointList'].includes(
                attrItem?.fieldName,
              )
                ? cuePointCondition
                : addMoreItemRef
            })
            const copyattributeValue = attributeValue?.filter(
              (item: any) => Object.keys(item)?.length,
            )

            if (copyattributeValue && validateEmptyValue(copyattributeValue))
              attr[metaAttribute.fieldName] = copyattributeValue
            else attr[metaAttribute.fieldName] = []
          }

          if (
            metaAttribute?.fieldType === CONSTANTS.FIELDTYPES.COMPLEXTYPE &&
            !metaAttribute?.addMore &&
            metaAttribute?.fieldName
          ) {
            if (!(metaAttribute.fieldName in attr)) {
              attr[metaAttribute.fieldName] = {}
            }
            for (const metaAttrChlild of metaAttribute.attribute.attributeRef) {
              if (metaAttrChlild?.fieldName)
                attr[metaAttribute.fieldName][metaAttrChlild.fieldName] = getValuesAttributeField(
                  metaAttrChlild?.attribute?.value,
                  metaAttrChlild.attribute,
                )
            }
          }
        }
      }
    }
  } else {
    return {}
  }

  return attr
}

export const validateForEmptyValues = (value: any) => {
  return value === '' || value === null || value === undefined || value?.length === 0
}

export const checkRequiredFieldsValue = (isRequiredData: any) => {
  let fieldCheck = false
  let attributeCheck = false
  let addMoreAttrCheck = false
  for (const attr of isRequiredData) {
    if (attr.fieldType !== CONSTANTS.FIELDTYPES.COMPLEXTYPE) {
      if (validateForEmptyValues(attr?.attribute?.value ?? '')) {
        fieldCheck = true
      }
    }

    if (attr.fieldType === CONSTANTS.FIELDTYPES.COMPLEXTYPE && attr?.addMore) {
      const isReqDataComplex = attr.attribute
        .flatMap((item: any) => [...item.attributeRef])
        .filter((itemC: any) => itemC?.isRequired)
      for (const attrChild of isReqDataComplex) {
        if (validateForEmptyValues(attrChild?.attribute?.value ?? '')) {
          addMoreAttrCheck = true
        }
      }
    }

    if (attr.fieldType === CONSTANTS.FIELDTYPES.COMPLEXTYPE && !attr?.addMore) {
      const isReqDataComplex = attr.attribute.attributeRef.filter((itemC: any) => itemC?.isRequired)
      for (const attrChild of isReqDataComplex) {
        if (
          !attrChild?.attribute?.value ||
          attrChild?.attribute?.value === '' ||
          JSON.stringify(attrChild?.attribute?.value) === '[]'
        ) {
          attributeCheck = true
        }
      }
    }
  }
  return fieldCheck || attributeCheck || addMoreAttrCheck
  // setMarkAsDone(fieldCheck || attributeCheck || addMoreAttrCheck)
}

export const getMarkDoneStatus = (
  attr: any,
  metaCategory: string,
  asset: any,
  detailViewState: any,
) => {
  const m: any = metaCategory
  const tollgate = asset?.tollGate?.[m]
  const permissionsCheck: any = checkForRolePermissions(tollgate, metaCategory)
  if (permissionsCheck !== 'skip') {
    // setMarkAsDone(permissionsCheck)
    return permissionsCheck
  }
  if (tollgate) {
    const isRequiredData = attr ? attr.filter((item: any) => item?.isRequired) : []
    return checkRequiredFieldsValue(isRequiredData)
  } else {
    return detailViewState?.data?.state === 'CREATED'
    // setMarkAsDone(detailViewState?.data?.state === 'CREATED')
  }
}

export const handleErrors = (array: any, metaCategory: any): any => {
  const result: any = {}

  array.forEach((item: any) => {
    const matchs = item.match(/"([^"]+)"/)
    const keys = matchs[1].split('.')
    let currentObj: any = result

    keys.forEach((key: any, index: any, array: any) => {
      const matches = key.match(/(.+?)\[(\d+)\]/) // NOSONAR
      const isArrayElement = matches !== null
      const keyWithoutArray = isArrayElement ? matches[1] : key
      if (!currentObj[keyWithoutArray]) {
        if (index === array.length - 1) {
          currentObj[keyWithoutArray] = keyWithoutArray + ' ' + item?.split?.(matchs[0])[1]
        } else {
          currentObj[keyWithoutArray] = isArrayElement ? [] : {}
        }
      }
      if (isArrayElement) {
        const arrayIndex = parseInt(matches[2])
        ensureArrayLength(currentObj[keyWithoutArray], arrayIndex + 1)
        currentObj = currentObj[keyWithoutArray][arrayIndex]
      } else {
        currentObj = currentObj[keyWithoutArray]
      }
    })
  })

  if (result?.[metaCategory as string]) {
    const validation = { ...result?.[metaCategory as string] }
    const validationKeys = Object.entries(validation)
    if (validationKeys?.length) {
      document.getElementById(validationKeys[0][0])?.focus()
    }
  }
  return result
}

export const addAssetValidationErrorsToChecklist = (
  versionId: string,
  assetValidationError: any,
  categories: any,
) => {
  if (versionId && assetValidationError[versionId]?.[CONSTANTS.CATEGORIES.CHECKLIST]) {
    categories.forEach((category: any, index: number) => {
      const validationErrors = assetValidationError[versionId][CONSTANTS.CATEGORIES.CHECKLIST]
      const categoryErrors = validationErrors.find(
        (error: any) => error.metaCategoryKey === category.metaCategoryKey,
      )
      if (categoryErrors) {
        categories[index] = categoryErrors
      }
    })
  }
}

export const isMutiAudioFeatureEnabled = (config: any, assetType = '') => {
  const { enabled, allowedAssetTypes } = config || {}
  if (!enabled) {
    return false
  }
  if (allowedAssetTypes?.length && assetType) {
    const isEnabled = allowedAssetTypes?.find((item: any) => item === assetType)
    return !!isEnabled
  }
}

export const hasIncompleteMarkDoneLangVariants = (
  languageVariants: any,
  baseId: any,
  metaCategoryKey: string,
) => {
  const base = languageVariants.find((item: any) => item.contentDetails._id === baseId)

  if (!base) return false

  return languageVariants.some((item: any) => {
    return (
      item.contentDetails.state === CONSTANTS.ASSET_STATUS.CREATED &&
      item.baseContentId === base.contentDetails.contentId &&
      base.variantAssetLanguages?.includes(item.defaultLang) &&
      item.metaCategories?.some(
        (meta: any) => meta.metaCategoryKey === metaCategoryKey && meta.markDoneStatus !== 'PASS',
      )
    )
  })
}

export const langVariantCategoryMarkDoneStatus = (
  attributes: any[],
  langVariants: any[],
  baseId: any,
): void => {
  attributes.forEach((item) => {
    if (
      CONFIG.ALLOWED_LANG_VARIANT_CATEGORY.includes(item.metaCategoryKey) &&
      langVariants?.length
    ) {
      const langVariantStatus = hasIncompleteMarkDoneLangVariants(
        langVariants,
        baseId,
        item.metaCategoryKey,
      )
      if (item.markDoneStatus === CONSTANTS.MARK_DONE_STATUS.PASS && langVariantStatus) {
        item.markDoneStatus = CONSTANTS.MARK_DONE_STATUS.NO_ACTION
      }
    }
  })
}

const getLanguageVariantScheduleDetailsHelper = async (
  variant: any,
  dispatch: any,
  setLoader: any,
) => {
  const request = API_CONFIG(API_LIST.CONTENT.SCHEDULE_LIST, {}, { contentId: variant?.contentId })

  dispatch(setLoader(true))

  try {
    const result: any = await mainApiService(request)

    if (result?.data?.length) {
      const details = result.data.find((item: any) => item?.contentId === variant?._id)
      if (details) {
        return details
      }
    }
  } catch {
    // intentionally silent
  } finally {
    dispatch(setLoader(false))
  }

  return null
}

export const getVariantRequestByStatus = async ({
  type,
  variant,
  values,
  dispatch,
  setLoader,
}: {
  type: string
  variant: any
  values: any
  dispatch: any
  setLoader: any
}) => {
  let scheduleDetails = null

  if (
    type === CONSTANTS.ASSET_STATUS.CREATE_SCHEDULE ||
    type === CONSTANTS.ASSET_STATUS.DELETE_SCHEDULE
  ) {
    scheduleDetails = await getLanguageVariantScheduleDetailsHelper(variant, dispatch, setLoader)
  }
  switch (type) {
    case CONSTANTS.ASSET_STATUS.PUBLISHED:
      return API_CONFIG(API_LIST.CONTENT.PUBLISH_CONTENT, { contentId: variant?._id }, null, null, {
        'service-id': 'BLITZ_FE',
      })

    case CONSTANTS.ASSET_STATUS.DE_PUBLISH:
      return API_CONFIG(
        API_LIST.CONTENT.DEPUBLISH_CONTENT,
        { contentId: variant?._id },
        null,
        null,
        { 'service-id': 'BLITZ_FE' },
      )

    case CONSTANTS.ASSET_STATUS.RE_PUBLISHED:
      return API_CONFIG(
        API_LIST.CONTENT.REPUBLISH_CONTENT,
        { contentId: variant?._id },
        null,
        null,
        { 'service-id': 'BLITZ_FE' },
      )

    case CONSTANTS.ASSET_STATUS.LIST_SCHEDULE:
      return API_CONFIG(API_LIST.CONTENT.SCHEDULE_LIST, {}, { contentId: variant?.blitzId })

    case CONSTANTS.ASSET_STATUS.CREATE_SCHEDULE:
      return API_CONFIG(
        API_LIST.CONTENT.SCHEDULE_CREATE,
        { contentId: variant?._id, ...values },
        null,
        null,
        { 'service-id': 'BLITZ_FE' },
      )

    case CONSTANTS.ASSET_STATUS.UPDATE_SCHEDULE:
      return API_CONFIG(API_LIST.CONTENT.SCHEDULE_UPDATE, {
        scheduleId: scheduleDetails?._id,
        ...values,
      })

    case CONSTANTS.ASSET_STATUS.DELETE_SCHEDULE:
      return API_CONFIG(API_LIST.CONTENT.SCHEDULE_DELETE, undefined, {
        scheduleId: scheduleDetails?._id,
      })

    default:
      return null
  }
}
